/**
 * desc : 图片展示样式-吸底
 */
<template>
  <section>
    <div :style="`background-color: ${backgroundColor}`" class="comp-image-button" v-if="isFixed">
      <div v-for="(image, index) in imgs" :key="index" data-actionid="1" data-itemtext="图片类组件" :data-itemotherinfo="getLink(image)" @click.stop="clickBtn($event, image, index)"
        v-show="(image.type!=='share' || (image.type=='share'&&isApp)) && image.show"
      >
        <img width="100%" :src="`${picHost+image.imgLink}`" @load="loadHandler">
      </div>
    </div>
  </section>
</template>
<script>
/* eslint-disable */
import { throttle } from '@/utils'
import mixin from './image_mixin.js'
import { eventBus } from '@/utils' 

export default {
  mixins: [mixin],
  data() {
    const { isTujiaAppEnv, isCtripAppEnv, isQunarAppEnv } = this.platformEnv
    return {
      isFixed: true,
      isApp: isTujiaAppEnv || isCtripAppEnv || isQunarAppEnv
    }
  },
  computed: {
    backgroundColor() {
      if (this.compProps.privateProps) {
        return this.compProps.privateProps.backgroundColor
      }
    }
  },
  created() {
    this.listenInScroll = throttle(16, this.listenInScroll).bind(this)
    window.addEventListener('scroll', this.listenInScroll, false)
  },
  destroyed() {
    window.removeEventListener('scroll', this.listenInScroll, false)
  },
  mounted() {},
  methods: {
    loadHandler($event) {
      eventBus.$emit('imageOnload')
    },
    listenInScroll() {
      // 当前页面的滚动条纵坐标位置
      let scrollTop = document.getElementsByTagName('html')[0].scrollTop || document.getElementsByTagName('body')[0].scrollTop
      // 滚动条的总高度
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      // windowHeight 是可视区的高度
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
      // let scrollTop1 = document.documentElement.scrollTop || document.body.scrollTop
      // 滚动条到底部得距离 = 滚动条的总高度 - 可视区的高度 - 当前页面的滚动条纵坐标位置
      var scrollBottom = scrollHeight - windowHeight - scrollTop
      if (scrollBottom > windowHeight * 0.1) {
        this.isFixed = true
      } else {
        this.isFixed = false
      }
    },
    clickBtn(event, image, index) {
      this.clickHandle(image, index)
      event.stopPropagation();
    }
  }
}
</script>
<style lang="scss" scoped>
.comp-image-button {
  width: 100%;
  display: flex;
  position: fixed;
  bottom: 0;
  z-index: 10;
  > div {
    width: 100%;
    font-size: 0;
  }
}
</style>
